import React from 'react'
import { Flex, Spinner } from '@chakra-ui/react'

export default function FullPageSpinner() {
  return (
    <Flex minHeight="100vh" width="full" align="center" justifyContent="center"
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        color="teal.500"
        size="xl"
      />
    </Flex>
  )
}
